import axios from "axios";

const show422 = (data) => {
  const lines = [];
  if (data?.ExceptionMessage) lines.push(data.ExceptionMessage);
  if (data?.ValidationErrors?.length > 0) {
    data.ValidationErrors.forEach((v) => {
      v?.Errors?.forEach((msg) => lines.push(`• ${v.Property}: ${msg}`));
    });
  }
  if (lines.length > 0) alert(lines.join("\n"));
};

const filesystemapi = axios.create({
  timeout: 10000,
  baseURL: "https://filesystem.altinisiksystem.com/api/v1",
});

filesystemapi.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { status, response } = error;

    let data = response?.data;

    if (data instanceof Blob) {
      try {
        data = JSON.parse(await data.text());
      } catch {
        data = null;
      }
    }

    switch (status) {
      case 400:
        if (data?.ExceptionMessage) console.log(data.ExceptionMessage);
        break;
      case 422:
        show422(data);
        break;
      case 500:
        if (data?.ExceptionMessage) console.log(data.ExceptionMessage);
        break;
      default:
        console.log("Bağlantı başarısız, İnternet bağlantınızı kontrol edin.");
        break;
    }

    return Promise.reject(error);
  },
);

export default filesystemapi;
